import { Icon as PhosphorIcon, IconProps as PhosphorIconProps } from '@phosphor-icons/react'
import React from 'react'

import { Colors } from '@/theme/defaults'
import { theme } from '@/theme/theme'

export interface IconProps extends Omit<PhosphorIconProps, 'color'> {
  icon: PhosphorIcon
  size?: string | number
  color?: keyof Colors
}

// Note: This is a wrapper around the PhosphorIcon component to allow for dynamic sizing.
export const Icon = ({ icon: IconComponent, size, color, style, ...rest }: IconProps) => {
  return (
    <IconComponent
      {...rest}
      // Note: This is a workaround to allow for dynamic sizing.
      // Some browsers don't support sizing in rems, ems and relative units.
      style={{
        ...style,
        height: size,
        width: size,
      }}
      color={color ? theme.colors[color] : undefined}
      data-component-id="Icon"
    />
  )
}
